import React, { useState, useEffect, useRef } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Swal from "sweetalert2";

import api from "../../../API/api";
import { Badge, Box, Button, TablePagination, Typography } from "@mui/material";
import ResponsiveDialog from "../../../components/modal/prompt";
import CustomizedMenus from "../../../components/tools/menu";
import DebounceSpinner from "../../../components/common/debounce-spinner";
import { useDynamicPagesContext } from "../../../context/dynamic-pages-context";
import AddDynamicPageTypes from "./component/types";
import AddDynamicPage from "./component/addPageForm";
import EditDynamicPage from "./component/editPageForm";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#016b8b",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const DynamicPagesList = () => {
  const tableRef = useRef(null);
  const { types, pagesData, pagesLoader, getTypesData } =
    useDynamicPagesContext();
  const [getRow, setGetRow] = useState();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [open, setOpen] = React.useState(false);
  const [opendelete, setOpenDlete] = useState(false);

  // new states
  const [openTypesModal, setTypesModal] = useState(false);
  const [addPageModal, setAddPageModal] = useState(false);
  const [modalData, setModalData] = useState({});

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Client-side pagination: slice data for current page
  const paginatedData = pagesData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) || [];

  const handleClickOpen = (edit = false) => {
    setOpen(true);
  };
  const handleDeleteDoctor = () => {
    if (opendelete === true) {
      setOpenDlete(false);
    } else {
      setOpenDlete(true);
    }
  };
  const handleDelete = () => {
    api
      .deleteBlogs(getRow)
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          setOpenDlete(false);
          Swal.fire({
            title: "Success!",
            text: "Deleted Succeffully !",
            icon: "success",
            confirmButtonText: "Ok",
          });
          // viewOrders();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const menuButtons = [
    {
      id: 1,
      name: "edit",
      onClick: () => handleClickOpen(true),
      icon: "EditIcon",
    },
    {
      id: 2,
      name: "delete",
      onClick: handleDeleteDoctor,
      icon: "DeleteIcon",
    },
  ];

  useEffect(() => {
    console.log(getRow, "getRow");
  }, [getRow]);

  return (
    <>
      <Box
        className="flex gap-2"
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 12,
          margin: 1,
        }}
      >
        <Button
          variant="contained"
          onClick={() => {
            setTypesModal(true);
          }}
        >
          Add Pages Types
        </Button>
        <Button
          className="ml-2"
          variant="contained"
          onClick={() => {
            setAddPageModal(true);
          }}
        >
          Add Page
        </Button>
      </Box>
      <Typography>
        *Note: Only one type can be added for one page , multiple will conflict <br />
        change these pages description for now , do not add new pages . some code are hard codded on site 
      </Typography>
      {pagesLoader && <DebounceSpinner isDebouncing={pagesLoader} />}
      <TableContainer component={Paper} ref={tableRef}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>ID</StyledTableCell>
              <StyledTableCell align="center">Title</StyledTableCell>
              <StyledTableCell align="center">Description</StyledTableCell>
              <StyledTableCell align="center">Page type</StyledTableCell>
              <StyledTableCell align="center">Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.map((row, index) => (
                <StyledTableRow key={row.id}>
                  <StyledTableCell component="th" scope="row">
                    {page * rowsPerPage + index + 1}
                  </StyledTableCell>
                  <StyledTableCell align="center">{row.title}</StyledTableCell>
                  <StyledTableCell align="center">
                    <div
                    style={{height : 100 , overflow : 'hidden', width : '50vw'}}
                      dangerouslySetInnerHTML={{ __html: row.description }}
                    />
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {getTypesData(row).title}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <Button
                      size="small"
                      onClick={() => {
                        setOpen(true);
                        setModalData(row);
                      }}
                    >
                      Edit
                    </Button>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={pagesData?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <ResponsiveDialog
        modalOpen={open}
        setModalOpen={setOpen}
        form={<EditDynamicPage editPageData={modalData} />}
        title={"Add Testimonials"}
        cancelButtonText={"cancel"}
        submitButtonText={" "}
        size="lg"
      />

      <ResponsiveDialog
        modalOpen={opendelete}
        setModalOpen={setOpenDlete}
        form={
          <>
            <button className="btn btn-danger me-3" onClick={handleDelete}>
              Delete{" "}
            </button>
            <button className="btn btn-success" onClick={handleDeleteDoctor}>
              Cancel
            </button>
          </>
        }
        title={"Are you sure ?"}
        cancelButtonText={" "}
        submitButtonText={" "}
        size="lg"
      />

      {/* check add edit types */}
      <ResponsiveDialog
        modalOpen={openTypesModal}
        setModalOpen={setTypesModal}
        form={<AddDynamicPageTypes />}
        title={"Add Page Types"}
        cancelButtonText={"cancel"}
        submitButtonText={" "}
        size="xl"
        modalSize={"100px"}
      />
      {/* check add edit types */}

      {/* add page modal */}
      <ResponsiveDialog
        modalOpen={addPageModal}
        setModalOpen={setAddPageModal}
        form={<AddDynamicPage />}
        title={"Add Page"}
        cancelButtonText={"cancel"}
        submitButtonText={" "}
        size="xl"
        modalSize={"100px"}
      />
      {/* add page modal */}
    </>
  );
};

export default DynamicPagesList;
